<script>

export default {
    props: {
        room: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            data: {},
        }
    },
    watch: {
        room() {
            var vm = this;

            vm.load();
        }
    },
    mounted() {
        var vm = this;

        vm.load();
    },
    methods: {
        load() {
            var vm = this;

            vm.create();
        },
        create() {
            var vm = this;

            vm.data = Object.assign({}, vm.room);
        },
        newData() {
            var vm = this;

            var data = {
                id: null,
                branch_id: null,
                name: null,
            };

            vm.data = Object.assign({}, data);
        },
        async submit() {
            var vm = this;
            this.$loading.on('room_detail_config_submit');

            try {
                var postData = vm._createPostData(vm.data);
                var resp = await this.$api.Room.create(postData);

                var data = resp.data;

                vm.create();
                vm.$emit('onUpdate');

                this.$flash.success(data.message);
            } catch (err) {
                this.$flash.error(err.response.data.message);
            }
            this.$loading.off('room_detail_config_submit');
        },
        _createPostData(data) {

            return data;
        },
        async destroy() {
            var vm = this;

            vm.$alert.confirm(vm.$t('basic.alert.delete'), async function (result) {
                if (result.isConfirmed) {
                    var id = vm.$route.params.id;

                    var params = {
                        id: id,
                        is_permanent: 0
                    };

                    try {
                        vm.$loading.on('room_detail_config_delete');

                        var resp = await vm.$api.Room.delete(params);

                        vm.$router.back();

                        vm.$flash.success(resp.data.message);
                    } catch (error) {
                        vm.$flash.error(error.response.data.message);
                    }

                    vm.$loading.off('room_detail_config_delete');
                }
            });
        },
        fetchBranch: async function (params) {
            const resp = await this.$api.Branch.all(params)

            const data = resp.data.data

            const list = data.map(row => ({
                id: row.id,
                text: row.text,
                model: row,
            }))

            const meta = resp.data.meta

            return {
                options: list,
                more: meta.current_page < meta.last_page
            }
        },
    }
};
</script>

<template>
    <BRow class="justify-content-center">
        <BCol>
            <b-form @submit="submit()">
                <BCard no-body>
                    <BCardBody>
                        <loading :loading="$loading.get('room_detail_create')" variant="dark" type="block">
                            <BRow>
                                <BCol class="mb-3" lg="12" v-if="$ac.hasAccess('room_full_access')">
                                    <label class="form-label" for="product-title-input">{{ $t('room.label.ref_no')
                                        }}</label>
                                    <input type="text" class="form-control" v-model="data.ref_no"
                                        id="product-title-input" :placeholder="$t('room.placeholder.ref_no')" />
                                </BCol>
                                <BCol class="mb-3" lg="12" v-if="$ac.hasAccess('room_full_access')">
                                    <label for="choices-publish-status-input" class="form-label">{{
                                        $t('room.label.branch')
                                        }}</label>
                                    <dynamic-select v-model="data.branch_id"
                                        :loadOptions="fetchBranch"
                                        :placeholder="$t('room.placeholder.branch')"/>
                                </BCol>
                                <BCol class="mb-3" lg="12">
                                    <label class="form-label" for="product-title-input">{{
                                        $t('room.label.name')
                                        }}</label>
                                    <input type="text" class="form-control" v-model="data.name" id="product-title-input"
                                        :placeholder="$t('room.placeholder.name')" />
                                </BCol>
                                <BCol lg="12">
                                    <div class="hstack gap-2 justify-content-between">
                                        <BButton type="button" variant="danger" class="w-sm" @click="destroy(data.id)"
                                            :disabled="$loading.get('room_detail_config_delete')"
                                            v-if="($ac.hasAccess('room_full_access') || ($ac.hasAccess('room_delete') && $ac.hasAccessStore(data.store_id)))">
                                            <loading :loading="$loading.get('room_detail_config_delete')">
                                                <i class="mdi mdi-delete-outline"></i>
                                                {{ $t('basic.btn.delete') }} {{ $t('menu.sub_header.room') }}
                                            </loading>
                                        </BButton>
                                        <div class="d-flex gap-2"
                                            v-if="($ac.hasAccess('room_full_access') || ($ac.hasAccess('room_create') && $ac.hasAccessStore(data.store_id)))">
                                            <BButton type="submit" variant="success" class="w-sm"
                                                :disabled="$loading.get('room_detail_config_submit')">
                                                <loading :loading="$loading.get('room_detail_config_submit')">
                                                    <i class="mdi mdi-floppy me-1"></i>
                                                    {{ $t('basic.btn.save') }}
                                                </loading>
                                            </BButton>
                                        </div>
                                    </div>
                                </BCol>
                            </BRow>
                        </loading>
                    </BCardBody>
                </BCard>
            </b-form>
        </BCol>
    </BRow>
</template>